import { ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { useState, useEffect } from "react";

import { useSidebarContext } from "@/contexts/SidebarContext";
import "@/components/membership/Template/TemplateEditorStyles.css";

export default function CrossProductTabs() {
  const { updatePath, crossProductList1, crossProductList2 } =
    useSidebarContext();
  const [outerTabValue, setOuterTabValue] = useState(0);
  const [innerTabValue, setInnerTabValue] = useState(0);

  useEffect(() => {
    if (crossProductList1) {
      setOuterTabValue(0);
    }
    if (crossProductList2) {
      setInnerTabValue(0);
    }
  }, [crossProductList1, crossProductList2]);

  const handleOuterTabClick = (crossProduct1) => {
    updatePath(2, crossProduct1);
  };

  const handleInnerTabClick = (crossProduct2) => {
    updatePath(3, crossProduct2);
  };

  return (
    <>
      {crossProductList1 && (
        <Box
          data-testid="cross-product-tabs"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <List className="template-editor-mapperItem">
            {crossProductList1.map((cp, index) => (
              <ListItemButton
                className={
                  outerTabValue === index ? "selected-sidebar-category" : ""
                }
                key={index}
                selected={outerTabValue === index}
                onClick={() => {
                  setOuterTabValue(index);
                  handleOuterTabClick(cp);
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      className="template-editor-mapperItem-item-text"
                    >
                      {cp}
                    </Typography>
                  }
                />
              </ListItemButton>
            ))}
          </List>
          {crossProductList2 && (
            <List
              sx={{ display: "flex", justifyContent: "center", padding: "0" }}
            >
              {crossProductList2.map((cp, index) => (
                <ListItemButton
                  key={index}
                  className={
                    innerTabValue === index ? "selected-sidebar-category" : ""
                  }
                  selected={innerTabValue === index}
                  onClick={() => {
                    setInnerTabValue(index);
                    handleInnerTabClick(cp);
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="body1"
                        className="template-editor-mapperItem-nestedItemText"
                      >
                        {cp}
                      </Typography>
                    }
                  />
                </ListItemButton>
              ))}
            </List>
          )}
        </Box>
      )}
    </>
  );
}
